let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cdH38")).then(() => parcelRequire('hlIyV'));